import { getFeatureStatusByTitle } from "./feature_helper";

import store from '../store';

const getActiveModuleInfos = () => {
	const { 
		Modules : modules
	} = store.getState();

	return modules.list.find((m) => m.name === modules.active);
}

const isSettingEnabledForActiveModule = (settingKey) => {
	const activeModule = getActiveModuleInfos();

	return (activeModule && activeModule.settings && (!!activeModule.settings[settingKey]));
}

const isFeatureEnabledForActiveModule = (featureName) => {
	const activeModule = getActiveModuleInfos();

	return (activeModule && activeModule.features && getFeatureStatusByTitle(activeModule.features, featureName))
}

export { 
	getActiveModuleInfos,
	isSettingEnabledForActiveModule,
	isFeatureEnabledForActiveModule
};